import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import images from './images'
/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::store
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:40
* @route '/license-scans'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/license-scans',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::store
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:40
* @route '/license-scans'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::store
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:40
* @route '/license-scans'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::store
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:40
* @route '/license-scans'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::store
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:40
* @route '/license-scans'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::retry
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:89
* @route '/license-scans/retry'
*/
export const retry = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(options),
    method: 'post',
})

retry.definition = {
    methods: ["post"],
    url: '/license-scans/retry',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::retry
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:89
* @route '/license-scans/retry'
*/
retry.url = (options?: RouteQueryOptions) => {
    return retry.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::retry
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:89
* @route '/license-scans/retry'
*/
retry.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::retry
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:89
* @route '/license-scans/retry'
*/
const retryForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::retry
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:89
* @route '/license-scans/retry'
*/
retryForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(options),
    method: 'post',
})

retry.form = retryForm

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::side
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:135
* @route '/license-scans/{licenseScan}/side'
*/
export const side = (args: { licenseScan: string | { id: string } } | [licenseScan: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: side.url(args, options),
    method: 'patch',
})

side.definition = {
    methods: ["patch"],
    url: '/license-scans/{licenseScan}/side',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::side
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:135
* @route '/license-scans/{licenseScan}/side'
*/
side.url = (args: { licenseScan: string | { id: string } } | [licenseScan: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { licenseScan: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { licenseScan: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            licenseScan: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        licenseScan: typeof args.licenseScan === 'object'
        ? args.licenseScan.id
        : args.licenseScan,
    }

    return side.definition.url
            .replace('{licenseScan}', parsedArgs.licenseScan.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::side
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:135
* @route '/license-scans/{licenseScan}/side'
*/
side.patch = (args: { licenseScan: string | { id: string } } | [licenseScan: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: side.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::side
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:135
* @route '/license-scans/{licenseScan}/side'
*/
const sideForm = (args: { licenseScan: string | { id: string } } | [licenseScan: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: side.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::side
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:135
* @route '/license-scans/{licenseScan}/side'
*/
sideForm.patch = (args: { licenseScan: string | { id: string } } | [licenseScan: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: side.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

side.form = sideForm

const licenseScans = {
    store: Object.assign(store, store),
    retry: Object.assign(retry, retry),
    side: Object.assign(side, side),
    images: Object.assign(images, images),
}

export default licenseScans